import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";

export const Footer = () => {
	return (
		<Column
			crossAxisAlignment="center"
			mainAxisAlignment="center"
			className="py-4 md:py-4 bg-[#2283D8] w-full mt-auto"
		>
			<Column className="text-center">
				<TextComponent
					variant="h2"
					className="text-white"
				>
					EL FUTURO NO ES DESECHABLE
				</TextComponent>
				<TextComponent
					variant="h2"
					className="text-white"
				>
					CUIDEMOS EL MAÑANA
				</TextComponent>
			</Column>
			<img
				className="w-20"
				src="/logo.png"
				alt="logo de la pagina"
			/>
		</Column>
	);
};
